export default {
      id: "observations-icon-usage",
      viewBox: "0 0 26 30",
      url: __webpack_public_path__ + "sprite.svg#observations-icon",
      toString: function () {
        return this.url;
      }
    }